export enum FeatureKey {
  DisputesViaFileIngestion = 'disputes.via_file_ingestion',
  MerchantFacilityAccess = 'merchant_facility_access',
  MerchantReports = 'merchant_reports',
  MdEnabled = 'md_enabled',
  SelfService = 'merchant_service_requests',
  SpiCloudPairings = 'spi_cloud.pairings',
  SupportSlf = 'support.slf',
  SupportTlf = 'support.tlf',
  OnboardingConsumerErrorFile = 'onboarding_consumer.error_file_download',
  VasConnectService = 'vas_connect_service',
  ApexRewards = 'vas_connect_service.apex_rewards',
  IdvRecords = 'idv_records',
  SubTenantOrganisations = 'sub_tenant_organisations',
  SubTenantOrganisationsProvisionUser = 'sub_tenant_organisations.provision_user',
  MerchantOrganisationsEntityType = 'merchant_orgs.entity_type',
  MerchantOrganisationsListShowSubTenant = 'merchant_orgs.list.show_sub_tenant',
  MerchantFacilityListShowSubTenant = 'merchant_facilities.list.show_sub_tenant',
  MultiMerchant = 'multi_merchant',
  MerchantApplications = 'merchant_applications',
  MerchantApplicationsListShowSubTenant = 'merchant_applications.list.show_sub_tenant',
  MerchantApplicationsListShowCountry = 'merchant_applications.list.show_country',
  MerchantPayouts = 'merchant_payouts',
  MerchantPayoutsAutomation = 'merchant_payouts.automation',
  MerchantPayoutsListLedgerEntries = 'merchant_payouts.list_ledger_entries',
  MerchantFacilitiesSettlementBankAccount = 'merchant_facilities.settlement_bank_account',
  MerchantFacilitiesShowServiceFees = 'merchant_facilities.view.show_msf_schedules',
  MerchantFacilitiesShowAcquirer = 'merchant_facilities.acquirer',
  MerchantFacilitiesShowRisk = 'merchant_facilities.view.show_risk_fields',
  AmexWholesale = 'amex_wholesale',
  DevicesRegisterByCode = 'devices.register_via_code',
  ManualOperatorManagement = 'manual_operator_management',
  TapApp = 'tap_app',
  HealthTransactions = 'health_transactions',
  WorkloadCronJobs = 'workload.cronjobs',
}

export enum FeatureStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export type FeatureList = {
  key: FeatureKey;
  status: FeatureStatus;
}[];

export interface GetFeaturesResp {
  data: FeatureList;
}
